<template>
  <div class="sign_container" ref="imageTofile">
    <Tabbar v-show="submitShow" data-html2canvas-ignore title="Online Signing" background="#378e5b"></Tabbar>
    <div class="sign_title">Chamet's Agency (Cooperation) Contract</div>
    <div class="sign_content">
      Party A: FULIAO HONG KONG LIMITED<br />
      SUITE 603, 6/F LAWS COMM PLAZA 788 CHEUNG SHA WAN RD KL<br />
      Tel: +85266812971<br />
      Party B: <br />
      <div v-show="inputShow">
        <div>Name:<input type="text" v-model="userInputData.name" /></div>
        <div>Address:<input type="text" v-model="userInputData.address" /></div>
        <div>Phone Number:<input type="text" v-model="userInputData.phone" /></div>
      </div>
      <div v-show="!inputShow">
        <div class="flex">
          Name:
          <div class="input_box">{{ userInputData.name }}</div>
        </div>
        <div class="flex">
          Address:
          <span class="input_box">{{ userInputData.address }} </span>
        </div>
        <div class="flex">
          Phone Number:
          <span class="input_box">{{ userInputData.phone }} </span>
        </div>
      </div>
      In order toachieve the common goal, after negotiation with each other equally,<br />
      Parties reach an agreement as follows:<br />
      <br />
      Ⅰ. General<br />
      Party A is an Internet company and runs a Social application named Chamet published on Google Play and Apple Store
      (hereinafter referred to as "Chamet"), now entrusts Party B to recruit, training and manage the hostesses. <br />
      Party B is an Agent who agrees to accept the entrustment of Party A and cooperate with Party A to operate Chamet.
      <br />
      <br />
      Ⅱ. The term of cooperation shall be one year. <br />
      <br />
      Ⅲ. Party A Right and Incumbency<br />
      1. Party A shall have the right to formulate Chamet's platform specifications, including but not limited to
      platform rules, user agreement, anchor assessment standards, etc. <br />
      2. Party A agrees to pay for the corresponding service fee under the condition that Party B and her hostesses
      fully performed the contract.
      <br />
      3. If Party B's hostesses violate Chamet's platform specifications, Party A shall have the right to suspend their
      work or even cancel their hostesses’ qualifications. <br />
      4.Party A shall have the right to use the relevant video materials of Party B's hostesses (including but not
      limited to video, audio, etc.) for free, for the purpose of publicizing and promoting Chamet. <br />
      <br />
      Ⅳ. Party B Right and Incumbency <br />
      1. Party B undertakes to provide and manage hostesses as required by Party A, arrange and supervise hostesses to
      abide by Chamet's platform specifications. <br />
      2. Party B shall have the obligation to supervise and manage the behavior of her hostesses. The hostesses must
      follow the policy of Chamet as below:<br />
      ● All anchors must be over 18 years old <br />
      ● Pornographic, violent, political contents are strictly prohibited <br />
      ● A hostess can register one Chamet account only <br />
      ● Hostesses are not allowed to switch agencies without permission <br />
      <br />
      Ⅴ. Payment <br />
      1. Party A generates salary list of hostesses and corresponding commission on every Monday (UTC+8), sends salaries
      and the commission on every Thursday (UTC+8) <br />
      2.Party A sends the salaries and the commission via various payment methods to Party B. <br />
      3. The salary structure of hostesses and the commission for Party B are calculated according to the additional
      agreement <br />
      <br />
      Ⅵ. Liability for Breach. If any Party breaches any provision of this Agreement, the breaching Party shall
      compensate another Party for all losses suffered by the other Party as a result of such breach. The Compliance
      Party can choose to terminate the contract without payment of a fee. <br />
      <br />
      Ⅶ. Governing Law and Dispute Resolution. This Agreement shall be governed in all respects by the laws of the place
      where the contract is signed, without giving effect to the principles of conflicts of laws thereunder. The parties
      agree to negotiate in good faith to resolve any dispute between them regarding this Agreement. If the negotiations
      do not resolve the dispute, each Party shall be entitled to recover the cost of enforcing the understanding and
      agreements as reflected herein in any court of competent jurisdiction, including, without limitation, any
      attorney’s fees incurred.<br />
      <br />
      Party A: FULIAO HONG KONG LIMITED
    </div>
    <div class="signA_box">
      <div class="flex">
        <div class="flex">Signature</div>
        <div class="date">Date: {{ agentContractDate }}</div>
      </div>
    </div>
    <img class="sign_img" src="../assets/signA.png" alt="" />

    <div class="signA_box">
      <div class="flex">
        <div class="flex">
          Signature
          <div data-html2canvas-ignore @click="signNow" class="sign_btn">{{ signBtn }}</div>
        </div>
        <div class="date">Date: {{ agentContractDate }}</div>
      </div>
    </div>
    <ESignature page="signImg" @cancel="cancel" v-show="signShow"></ESignature>
    <ScreenAndSubmit
      data-html2canvas-ignore
      v-show="submitShow"
      :signImgSrc="signImgSrc"
      :userInputData="userInputData"
      @showInputFun="showInputFun"
      page="contractImg"
    ></ScreenAndSubmit>
    <img class="sign_img" v-show="signImgShow" :src="signImgSrc" alt="" />
  </div>
</template>

<script>
import Tabbar from '@/components/Tabbar.vue'
import ESignature from '@/components/ESignature.vue'
import ScreenAndSubmit from '@/components/ScreenAndSubmit.vue'

export default {
  name: 'Signing',
  components: { ESignature, Tabbar, ScreenAndSubmit },
  data() {
    return {
      signShow: false,
      submitShow: true,
      signImgShow: false,
      signImgSrc: '',
      signBtn: 'Sign Now',
      agentContractDate: '',
      currentDate: '',
      userInputData: {
        name: '',
        address: '',
        phone: ''
      },
      inputShow: true
    }
  },
  mounted() {
    if (sessionStorage.getItem('agentContractDate')) {
      this.agentContractDate = sessionStorage.getItem('agentContractDate')
    }
    if (sessionStorage.getItem('signImg')) {
      this.signImgShow = true
      this.signImgSrc = sessionStorage.getItem('signImg')
      this.signBtn = 'Resign'
    }
    if (sessionStorage.getItem('userInputData')) {
      this.userInputData = JSON.parse(sessionStorage.getItem('userInputData'))
    }
    this.getdataTime()
  },
  methods: {
    showInputFun(inputShow) {
      this.inputShow = inputShow
      console.log(this.inputShow)
    },
    signNow() {
      this.signShow = true
      this.submitShow = false
      sessionStorage.setItem('userInputData', JSON.stringify(this.userInputData))
    },
    cancel() {
      this.signShow = false
      this.submitShow = true
    },
    getdataTime() {
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      this.currentDate = yy + '-' + (mm < 10 ? '0' + mm : mm) + '-' + (dd < 10 ? '0' + dd : dd)
    }
  }
}
</script>

<style scoped>
img {
  display: block;
}
.sign_container {
  width: 100vw;
  height: 100%;
  font-size: 0.14rem;
  padding: 0.18rem 0.18rem 1rem;
  box-sizing: border-box;
  overflow-y: auto;
  background: url(../assets/chamet_logo_bg.png) repeat;
  text-align: left;
}

.sign_title {
  font-size: 0.16rem;
  font-weight: 500;
  margin-bottom: 0.14rem;
}

.sign_content {
  text-align: left;
  line-height: 0.2rem;
}

.date {
  margin-inline-start: 0.5rem;
}

.sign_img {
  width: 1rem;
  height: 0.6rem;
  object-fit: contain;
}

.sign_btn {
  width: max-content;
  background: #378e5b;
  color: #fff;
  padding: 0.03rem 0.1rem;
  box-sizing: border-box;
  text-align: center;
  border-radius: 0.2rem;
  margin-inline-start: 0.1rem;
}

.flex {
  display: flex;
  align-items: center;
}

.input_box {
  min-width: 1rem;
  text-align: center;
  height: 0.2rem;
  position: relative;
  border-bottom: 1px solid #333;
  padding: 0 0.05rem;
  box-sizing: border-box;
}

input {
  border-bottom: 1px solid #333;
  padding: 0 0.05rem;
  box-sizing: border-box;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/Signing.vue